import { render, staticRenderFns } from "./reviewSheetold1.vue?vue&type=template&id=5a627735&scoped=true&"
import script from "./reviewSheetold1.vue?vue&type=script&lang=js&"
export * from "./reviewSheetold1.vue?vue&type=script&lang=js&"
import style0 from "./reviewSheetold1.vue?vue&type=style&index=0&id=5a627735&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a627735",
  null
  
)

export default component.exports